import { lazy } from 'react';

export const PermissionDeniedPage = lazy(() => import('./PermissionDeniedPage'));
export const AdminPermissionDeniedPage = lazy(() => import('./AdminPermissionDeniedPage'));
